module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAASFBMVEW2ttqbm83W1ut3d7vr6/VcXK4AAIAgIJBYWKxiYrFwcLh0dLqQkMioqNSvr9fExOLIyOTPz+fZ2ezg4PDh4fDy8vn19fr///+N8oBjAAAABnRSTlPs7u7x8/XoJD7XAAAAa0lEQVR42o3PSQ6AMAgFUDo4VXCqyv1vKnHV1AZ8Sz7hB+iFY+jb3jky/YiXrebLOPMHOETc+UAxp1qAYnVodAMRHXySmMZaZ3SX8Zpr0fjbiqPcuPjOTRFYBd2okMdUEJIiWN1+U3ij24gfg1Mb355OwQUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/gr.png
// module id = 830
// module chunks = 0